content-split-block {
  display: block;
  
  &[reverse="true"] {
    content-grid-formatter [slot="column1"],
    content-grid-formatter [slot="column1"] {
      order: 2;
    }

    content-grid-formatter [slot="column2"],
    content-grid-formatter [slot="column2"] {
      order: 1;
    }
  }
}